import { Link, useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: '页面不存在 - 禁止的爱善良的小姨子专题',
    description: '你访问的页面不存在或已被移除，可返回首页继续浏览剧情、演员与最新动态。',
  });

  return (
    <SiteLayout>
      <section className="mx-auto flex w-full max-w-[900px] flex-col items-center px-4 py-20 text-center md:px-8 md:py-28">
        <p className="font-heading text-6xl text-primary-200 md:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-2xl text-foreground-950 md:text-3xl">这一页没有找到</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
          你访问的地址 <span className="text-foreground-700">{location.pathname}</span> 不存在，可能是链接已经调整。
          可以回到首页，或从下面的入口继续浏览。
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-700"
          >
            返回首页
          </Link>
          <Link
            to="/category/plot"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            查看分集剧情
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}